import React from 'react';
import Arts from './icons/arts';
import Business from './icons/business';
import Science from './icons/science';
import Health from './icons/health';
import Food from './icons/food';
import Environment from './icons/environment';
import Education from './icons/education';
import Arrow from './icons/arrow';
import Eks from './icons/eks';
import CircleEks from './icons/circleEks';
import Pause from './icons/pause';
import Play from './icons/play';

// make references to the components by type
const components = {
  Art: Arts,
  Bus: Business,
  Sci: Science,
  Hea: Health,
  Foo: Food,
  Env: Environment,
  Edu: Education,
  Arr: Arrow,
  Eks: Eks,
  Cir: CircleEks,
  Pau: Pause,
  Pla: Play,
};

// a component that will render one or more components that it doesn't explicitly include in it's JSX
const Icon = (props) => {
  // make a reference using a Capitalized variable name to the component you need to render where props.type is one of 'Type1' or 'Type2'
  const Component = components[props.type];

  // use the reference to the component with the Capitalized variable name to render it
  return (<Component { ...props } />);
};

Icon.defaultProps = {
  type: "Arr",
}

export default Icon;